import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/glow555.png")